export class ImageModel {
  TypeId: number = 0;
  Url: string = '';
  ImageRatio: number = 0;
  PageType: number = 0;
  Caption: string = '';
  FixedImageWidth: number = 0;
  FixedImageHeight: number = 0;
}

export class CaptionModel {
  ImageId: number = 0;
  Caption: string = '';
}
